module.exports = __webpack_public_path__ + "static/img/compro_help4.bd0372b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/compro_help4.png
// module id = RWB8
// module chunks = 1